<template>
    <div class="container">
        <v-card>
                <v-card-title class="titulopagina">ADMINISTRAR PARAMETRO DETALLE</v-card-title>
                <v-card-text>
                    <v-btn color="green" fab small dark @click="crear">
                         <v-icon>add</v-icon>
                    </v-btn>
                </v-card-text>
                <!-- <Tabla :ajustes="this.ajustes" @editar="editar($event)"></Tabla> -->
            </v-card>

            <!-- <data-table class="mt-5" @editar="editar($event)" @asignarusuarios="asignarUsuario($event)"></data-table> -->
            <data-table-filtro class="mt-5" @editar="editar($event)" @asignarusuarios="asignarUsuario($event)"></data-table-filtro>

            <modal @peticionrealizada="cargarDatos"></modal>
            
            <!-- modal para asignar usuarios para las alarmas -->
            <modal-asignar-usuario @peticionrealizada="cargarDatos"></modal-asignar-usuario>
            <!-- modal para asignar usuarios para las alarmas -->

    </div>
</template>
<script>
import {mapState,mapMutations} from 'vuex'
//import Tabla from '@/components/shared/Tabla.vue'
import Data_Table from '@/components/shared/Data_Table.vue'
import Modal from '@/components/shared/Modal.vue'
import Data_Table_Filtro from '../../components/shared/Data_Table_Filtro.vue'
import Modal_Asignar_Usuarios from '../../components/shared/Modal_Asignar_Usuarios.vue'
// import axios from 'axios'
export default {
    data:()=>({
        lista:[],
        puntos_medicion:[],
        equipos_proceso:[],
        parametros:[],
        opciones_simbolos:[
            {nombre:'Ninguno',id:''},
            {nombre:'Mayor que (>=)',id:'>='},
            {nombre:'Menor que (<=)',id:'<='},
            // {nombre:'Igual a (=)',id:'=='}
        ],
        unidades_medida:[],
        inputs:[
            {tipo:'select',valor:'',label:'Seleccione Punto de Medición*',key:'punto_mediciones_id',opciones:[],texto:'nombre_punto',seleccion:'id'},
            {tipo:'select',valor:'',label:'Seleccione Equipo de Proceso*',key:'equipos_procesos_id',opciones:[],texto:'texto_definitivo',seleccion:'id'},
            {tipo:'select',valor:'',label:'Seleccione Parametro*',key:'parametros_id',opciones:[],texto:'nombre_parametro',seleccion:'id'},
            {tipo:'select',valor:'',label:'Seleccione Unidad de Medida*',key:'unidad_medidas_id',opciones:[],texto:'unidad_medida',seleccion:'id'},
            {tipo:'numero',valor:'',label:'Límite Mínimo*',key:'valor_minimo'},
            {tipo:'numero',valor:'',label:'Límite Máximo*',key:'valor_maximo'},
            {tipo:'select',valor:'',label:'Condicion Alarma 1',key:'signo01',opciones:[],texto:'nombre',seleccion:'id'},
            {tipo:'numero',valor:'',label:'Alarma 1*',key:'alarma01'},
            {tipo:'select',valor:'',label:'Condicion Alarma 2',key:'signo02',opciones:[],texto:'nombre',seleccion:'id'},
            {tipo:'numero',valor:'',label:'Alarma 2*',key:'alarma02'},
            {tipo:'numero',valor:'',label:'Optimo Mínimo*',key:'optimo_minimo'},
            {tipo:'numero',valor:'',label:'Optimo Máximo*',key:'optimo_maximo'},
            {tipo:'numero',valor:'',label:'Orden*',key:'orden'},
            {tipo:'numero',valor:'',label:'Cantidad de Decimales',key:'cantidad_decimales'},
            {tipo:'switch',valor:'',label:'Activo',key:'activo'},
            {tipo:'switch',valor:'',label:'Prorrateable',key:'prorrateable'}
        ],
        configuracion_modal:{
            titulo_modal:'',
            boton_submit:'',
            ruta:'',
            tipo_peticion:'',
            mensaje:'Considerar que si se configuran 2 alarmas, siempre la "Alarma 1" corresponda al valor "Mayor que"',
            tipo_mensaje:'info'
        },
        //configuracion para datatable
        cabeceras:[
            {
                text:'Punto de Medición',
                align:'center',
                sortable:true,
                filterable:true,
                busqueda:'',
                value:'punto_mediciones.nombre_punto',
                class:'cabecera'
            },
            {
                text: 'Tipo de Equipo',
                align: 'center',
                sortable: true,
                filterable:true,
                busqueda:'',
                value: 'equipos_procesos.tipo_equipo.tipo_equipo',
                class:'cabecera',
            },
            {
                text: 'Equipo de Proceso',
                align: 'center',
                sortable: true,
                filterable:true,
                busqueda:'',
                value: 'equipos_procesos.nombre_equipo',
                class:'cabecera',
            },
            {
                text: 'Parametro',
                align: 'center',
                sortable: true,
                filterable:true,
                busqueda:'',
                value: 'parametros.nombre_parametro',
                class:'cabecera',
            },
            {
                text: 'Unidad Medida',
                align: 'center',
                sortable: true,
                filterable:true,
                busqueda:'',
                value: 'unidad_medida.unidad_medida',
                class:'cabecera',
            },
            {
                text: 'Orden Parámetro',
                align: 'center',
                sortable: true,
                filterable:true,
                busqueda:'',
                value: 'orden',
                class:'cabecera',
            },
            {
                text: 'Activo',
                align: 'center',
                sortable: true,
                filterable:true,
                busqueda:'',
                value: 'activo',
                class:'cabecera',
            },
            //decimales
            // {
            //     text: 'Cantidad Decimales',
            //     align: 'center',
            //     sortable: true,
            //     filterable:true,
            //     busqueda:'',
            //     value: 'cantidad_decimales',
            //     class:'cabecera',
            // },
            {
                text: 'Alarma',
                align: 'center',
                sortable: true,
                filterable:true,
                busqueda:'',
                value: 'tiene_alarma',
                class:'cabecera',
            },
            { 
                text: 'Acciones', 
                value: 'action', 
                sortable: false,
                filterable:false, 
                align:'center',
                class:'cabecera',
            },
            {
                text: 'Usuarios Alarmas',
                align: 'center',
                sortable: false,
                filterable:false,
                value: 'asignar_usuarios',
                class:'cabecera',
            },
                
        ],
        acciones:[
                {key:'editar',titulo:'Editar',visible:true}
        ]
    }),
    created() {
        // Event.$on('peticion_realizada',()=>{
        //     this.cargarDatos()
        // })
    },
    mounted() {
        this.cargarPuntosMedicion()
        this.inputs[6].opciones = this.opciones_simbolos;
        this.inputs[8].opciones = this.opciones_simbolos;
    },
    methods: {
        async cargarDatos(){
            //this.mostrarLoading('Cargando Datos...')
            this.mostrarLoading({titulo:'Cargando Datos...',color:'green'})

            let url = `${this.base_url}parametro_detalles`
            await this.axios.get(url,this.headers).then((response)=>{
                console.log('respuesta',response);
                this.lista = response.data.data
                // response.data.data.forEach(item => {
                //     this.lista.push({id:item.id,tipo_equipo:item.tipo_equipo})
                // });
                Event.$emit('actualizar_lista',this.lista);
                Event.$emit('llenar_tabla',this.lista,this.cabeceras,this.acciones)
                Event.$emit('inicializar_tabla',this.cabeceras,this.lista,this.acciones)
                this.ocultarLoading()
            }).catch((error)=>{
                console.log(error)
                this.ocultarLoading()
            })
        },
        async cargarPuntosMedicion(){
            //this.mostrarLoading('Cargando Puntos de Medición...')
            this.mostrarLoading({titulo:'Cargando Puntos de Medición...',color:'green'})

            let url = `${this.base_url}punto_medicion`
            await this.axios.get(url,this.headers).then((response)=>{
                this.puntos_medicion = response.data.data
                this.inputs[0].opciones = this.puntos_medicion
                this.cargarEquiposProceso()
            }).catch((error)=>{
                console.log('error',error);
            })
        },
        async cargarEquiposProceso(){
            //this.mostrarLoading('Cargando Equipos de Proceso...')
            this.mostrarLoading({titulo:'Cargando Equipos de Proceso...',color:'green'})

            let url = `${this.base_url}equipo_procesos`
            await this.axios.get(url, this.headers).then((response) => {
                this.equipos_proceso = response.data.data.map(equipo => {
                    return {
                        ...equipo,
                        texto_definitivo: `${equipo.nombre_equipo} - ${equipo.tipo_equipo_nombre}` 
                    }
                })
                
                this.inputs[1].opciones = this.equipos_proceso
                console.log('this.inputs[1].opciones',this.inputs[1].opciones);
                this.cargarParametros()
            }).catch((error)=>{
                console.log('error',error);
            })
        },
        async cargarParametros(){
            //this.mostrarLoading('Cargando Parametros...')
            this.mostrarLoading({titulo:'Cargando Parametros...',color:'green'})

            let url = `${this.base_url}parametros`
            await this.axios.get(url,this.headers).then((response)=>{
                this.parametros = response.data.data
                this.inputs[2].opciones = this.parametros
                this.cargarUnidadesMedida()
            }).catch((error)=>{
                console.log('error',error);
            })
        },
        async cargarUnidadesMedida(){
            //this.mostrarLoading('Cargando Unidades de Medida...')
            this.mostrarLoading({titulo:'Cargando Unidades de Medida...',color:'green'})

            let url = `${this.base_url}unidad_medidas`
            await this.axios.get(url,this.headers).then((response)=>{
                this.unidades_medida = response.data.data
                this.inputs[3].opciones = this.unidades_medida
                this.cargarDatos()
            }).catch((error)=>{
                console.log('error',error);
            })
        },
        crear(){
            console.log('crear');
            this.configuracion_modal.titulo_modal = 'Crear Indicador Detalle'
            this.configuracion_modal.boton_submit = 'Crear'
            this.configuracion_modal.ruta = 'parametro_detalles'
            this.configuracion_modal.tipo_peticion = 'POST'
            this.$emit('abrir',this.inputs,this.configuracion_modal);
        },
        async editar($event){
            console.log('editando',$event);
            //por cada input se realiza el seteo correspondiente del item que se esta editando
            await this.inputs.forEach(input => {
                //recorrido del objeto a editar
                Object.keys($event).forEach(key => {
                    let valor = $event[key];
                    if(input.key == key){
                        input.valor = valor
                    }
                });
            });

            let punto_medicion = await this.$buscarObjeto($event['punto_mediciones_id'],this.puntos_medicion)
            this.inputs[0].valor = punto_medicion;

            let equipo_proceso = await this.$buscarObjeto($event['equipos_procesos_id'],this.equipos_proceso)
            this.inputs[1].valor = equipo_proceso;

            let parametro = await this.$buscarObjeto($event['parametros_id'],this.parametros)
            this.inputs[2].valor = parametro;

            let unidad_medida = await this.$buscarObjeto($event['unidad_medidas_id'],this.unidades_medida)
            this.inputs[3].valor = unidad_medida;

            let signo01 = await this.$buscarObjeto($event['signo01'],this.opciones_simbolos);
            this.inputs[6].valor = signo01;

            let signo02 = await this.$buscarObjeto($event['signo02'],this.opciones_simbolos);
            this.inputs[8].valor = signo02;

            console.log('inputs con datos a editar',this.inputs);
            this.configuracion_modal.titulo_modal = 'Editar Parametro Detalle'
            this.configuracion_modal.boton_submit = 'Actualizar'
            this.configuracion_modal.ruta = `parametro_detalles/${$event.id}`
            this.configuracion_modal.tipo_peticion = 'PUT'
            this.$emit('abrir',this.inputs,this.configuracion_modal);
        },

        asignarUsuario($event){
            console.log('asignar usuarios para alarmas',$event.id);
            let configuracion = {
                titulo:'Asignar Usuarios para Alarmas'
            };
            let usuarios = [];
            let actuales = $event['usuarios_alarmas'];
            actuales.forEach(usuario => {
                // console.log('usuario',usuario);
                usuarios.push(usuario.id)
            });
            Event.$emit('abrir_asignar_usuario',configuracion,usuarios,$event);
        },

        ...mapMutations(['mostrarLoading','ocultarLoading'])
    },
    computed: {
        ...mapState(['base_url','headers'])
    },
    components:{
        'modal':Modal,
        'data-table':Data_Table,
        'data-table-filtro':Data_Table_Filtro,
        'modal-asignar-usuario':Modal_Asignar_Usuarios
    }
}
</script>